import { Action } from "redux";
import { OrganizationKeyName } from "../../../model/Organization";
import { MonitorEventsSuccessResponse } from "../../../service/api-response/MonitorEventsSuccessResponse";
import { MonitorEventListFilters } from "../../../service/ApiMonitorEvent";

export const GET_USER_MONITOR_EVENT_LIST_SUCCESS =
  "USER-MONITOR-EVENT:GET_USER_MONITOR_EVENT_LIST_SUCCESS";

export interface GetUserMonitorEventListSuccessAction extends Action {
  type: typeof GET_USER_MONITOR_EVENT_LIST_SUCCESS;
  organization: OrganizationKeyName;
  data: MonitorEventsSuccessResponse;
  filters: MonitorEventListFilters;
}

export const getUserMonitorEventListSuccessAction = (
  organization: OrganizationKeyName,
  data: MonitorEventsSuccessResponse,
  filters: MonitorEventListFilters
): GetUserMonitorEventListSuccessAction => ({
  type: GET_USER_MONITOR_EVENT_LIST_SUCCESS,
  organization,
  data,
  filters,
});
